import { Input } from "antd";
import React from "react";
import { ControlHeaderProps } from "src/explore/components/ControlHeader";

interface PopoverContent extends ControlHeaderProps {
    label: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
}

const PopoverContent = (props: PopoverContent) => {
    const { label, onChange, value: initialValue } = props;

    // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setInputItem(e.target.value);
    //     onChange(label, e.target.value);
    // };
    // useEffect(() => {
    //     if (shouldReset) {
    //         setInputItem("");
    //     }
    // }, [shouldReset]);

    return (
        <div>
            <Input name={label} value={initialValue} onChange={onChange} />
        </div>
    );
};
export default React.memo(PopoverContent);
